import { useQuery } from 'react-query';
import { trackPromise } from 'react-promise-tracker';
import { getListMigPropertyLink } from '..';
export const useGetListLinks = (additionlInfo) => useQuery(['GetListLink', additionlInfo], () => trackPromise(getListMigPropertyLink(additionlInfo)), {
    cacheTime: 0,
});
